import React, { Fragment, useState, useEffect } from "react";
import {
  faTimes,
  faSave,
  faTrash,
  faCheck } from
"@fortawesome/free-solid-svg-icons";
import GetAdminService from "../../../services/admin/GetAdminService";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import swal from "sweetalert";
import { Modal, ModalBody } from "reactstrap";
import "../AdminPages.css";
import "../Student/Student.css";

const MessageModal = ({ isOpen, setIsOpen, data }) => {
  return (
    <Fragment>
      <Modal isOpen={isOpen} centered={true}>
        <ModalBody>
          <div style={{ textAlign: "center" }}>
            <p>{data.message}</p>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <button
                onClick={data.function1}
                style={{
                  backgroundColor: "#009900",
                  color: "white",
                  padding: "5px",
                  border: "none",
                  outline: "none",
                  marginRight: "20px",
                  borderRadius: "5px"
                }}>
                
                <FontAwesomeIcon
                  style={{ margin: "0 5px" }}
                  color="white"
                  icon={faCheck} />
                
                Ok
              </button>
              <button
                onClick={() => setIsOpen(false)}
                style={{
                  backgroundColor: "#efefef",
                  color: "black",
                  padding: "5px",
                  border: "none",
                  outline: "none",
                  marginLeft: "20px",
                  borderRadius: "5px"
                }}>
                
                <FontAwesomeIcon style={{ margin: "0 5px" }} icon={faTimes} />
                Cancel
              </button>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </Fragment>);

};

const CreateRecruiter = ({
  setOpenRecruiter,
  modify,
  college_id,
  recruiterCall
  //   getPageData,
  //   school_name,
}) => {

  const [firstName, setFirstName] = useState();
  const [lastName, setLastName] = useState();
  const [email, setEmail] = useState();
  const [recoveryEmail, setRecoveryEmail] = useState();
  const [mobile, setMobile] = useState();
  const [promote, setPromote] = useState(false);
  const [premium, setPremium] = useState(false); // Assign Premium Service flag
  const [password, setPassword] = useState();
  const [confirmPassword, setConfirmPassword] = useState();

  const [showPasswordError, setShowPasswordError] = useState("");
  const [openDeleteModal, setOpenDeleteModal] = useState(false);








  // const getSchoolsList = (value) => {
  //   setSchoolNameLoading(true);
  //   setShowSchoolNameContainer(true);
  //   GetAdminService.getSchoolsList(value)
  //     .then((data) => {
  //       setSchoolNameList(data?.data?.objects);
  //       setSchoolNameLoading(false);
  //     })
  //     .catch((error) => {
  //       setSchoolNameLoading(false);
  //     });
  // };


  const modifyData = () => {
    setFirstName(modify?.first_name || "");
    setLastName(modify?.last_name || "");
    setEmail(modify?.email || "");
    setRecoveryEmail(modify?.recovery_email || "");
    setMobile(modify?.mobile || "");
    setPromote(modify?.is_college_admin);
    setPremium(modify?.is_premium); // prefill premium flag on modify
  };

  const setNull = () => {
    setFirstName("");
    setLastName("");
    setEmail("");
    setMobile("");
    setPassword("");
    setConfirmPassword("");
  };

  const passwordValidation = (_value) => {
    if (!modify && password?.length < 8) {
      setShowPasswordError("Password must be greater than 8 characters");
    } else if (password?.length >= 8) {
      setShowPasswordError(false);
    }
  };

  const confirmPasswordValidation = (value) => {
    if (value !== password)
    setShowPasswordError("Password and Confirm Password should be same.");else
    setShowPasswordError(false);
  };

  const saveButtonHandler = () => {
    let obj = {
      college: college_id,
      first_name: firstName,
      last_name: lastName,
      email: email,
      recovery_email: recoveryEmail,
      mobile: mobile,
      type: "recruiter",
      is_college_admin: promote,
      is_premium: premium
    };
    obj.password = password;
    obj.password_confirm = confirmPassword;

    let obj1 = {
      user_id: modify?.id,
      old_email: modify?.email,
      old_firstname: modify?.first_name,
      old_lastname: modify?.last_name,
      first_name: firstName,
      last_name: lastName,
      email: email,
      recovery_email: recoveryEmail,
      mobile: mobile,
      type: "recruiter",
      is_college_admin: promote,
      is_premium: premium
    };
    if (modify) {
      GetAdminService.updateRecruiter(obj1, modify?.id)
      .then((_data) => {
        recruiterCall(college_id);
        setNull();
        //   getPageData(school_id);
        setOpenRecruiter(false);
      })
      .catch((error) => {
        swal({
          text: error?.response?.data?.message,
          icon: "warning",
          dangerMode: true,
          buttons: {
            cancel: true,
            confirm: true
          },
          closeOnClickOutside: true
        }).then((_value) => {
        });
      });
    } else {
      GetAdminService.saveRecruiter(obj)
      .then((_data) => {
        recruiterCall(college_id);
        setNull();
        //   getPageData(school_id);
        setOpenRecruiter(false);
      })
      .catch((error) => {
        swal({
          text: error?.response?.data?.message,
          icon: "warning",
          dangerMode: true,
          buttons: {
            cancel: true,
            confirm: true
          },
          closeOnClickOutside: true
        }).then((_value) => {
        });
      });
    }
  };

  const deleteCounslor = () => {
    // let obj = {
    //   college_id:modify?.id
    // }
    GetAdminService.deleteRecruiter(modify?.id)
    .then((_data) => {
      recruiterCall(college_id);
      swal({
        text: "Recruiter deleted successfully!",
        icon: "success",
        buttons: {
          confirm: true
        },
        closeOnClickOutside: false
      });
      setNull();
      // getPageData(school_id);
      setOpenRecruiter(false);
    })
    .catch(() => {});
    setOpenDeleteModal(false);
  };

  useEffect(() => {
    if (modify) {
      modifyData();
    }
  }, [modify]);

  return (
    <Fragment>
      <div className="create-student-container">
        <div className="drawer-header">
          <h3 className="drawer-title">
            {modify ? "Modify Recruiter" : "New Recruiter"}
          </h3>
          <button
            type="button"
            className="drawer-close-btn"
            onClick={() => {
              setOpenRecruiter(false);
              setNull();
            }}
            aria-label="Close">
            
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>

        <div className="drawer-section">
          <p className="drawer-section-label">Personal information</p>
          <div className="drawer-form-row">
            <div className="form-label-col">
              First Name
              <span className="required-marker">*</span>
            </div>
            <div className="form-field-col">
              <input
                type="text"
                placeholder="First Name"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)} />
              
            </div>
          </div>
          <div className="drawer-form-row">
            <div className="form-label-col">
              Last Name
              <span className="required-marker">*</span>
            </div>
            <div className="form-field-col">
              <input
                type="text"
                placeholder="Last Name"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)} />
              
            </div>
          </div>
        </div>

        <div className="drawer-section">
          <p className="drawer-section-label">Contact</p>
          <div className="drawer-form-row">
            <div className="form-label-col">
              Email
              <span className="required-marker">*</span>
            </div>
            <div className="form-field-col">
              <input
                type="email"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value.toLowerCase())} />
              
            </div>
          </div>

          <div className="drawer-form-row">
            <div className="form-label-col">Secondary Email</div>
            <div className="form-field-col">
              <input
                type="email"
                placeholder="Secondary Email"
                value={recoveryEmail}
                onChange={(e) => setRecoveryEmail(e.target.value.toLowerCase())} />
              
              <p className="help-text">
                Used in case account needs to be recovered
              </p>
            </div>
          </div>

          <div className="drawer-form-row">
            <div className="form-label-col">Mobile</div>
            <div className="form-field-col">
              <input
                type="text"
                placeholder="+19999999999"
                onChange={(e) => setMobile(e.target.value)}
                value={mobile} />
              
              <p className="help-text">Hint: +13238511115</p>
            </div>
          </div>
        </div>

        <div className="drawer-section">
          <p className="drawer-section-label">User information</p>
          <div className="drawer-form-row">
            <div className="form-label-col">
              Password
              <span className="required-marker">*</span>
            </div>
            <div className="form-field-col">
              <input
                type="password"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                onBlur={() => passwordValidation(password)} />
              
            </div>
          </div>
          <div className="drawer-form-row">
            <div className="form-label-col">
              Confirm Password
              <span className="required-marker">*</span>
            </div>
            <div className="form-field-col">
              <input
                type="password"
                placeholder="Confirm Password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                onBlur={() => confirmPasswordValidation(confirmPassword)} />
              
            </div>
          </div>

          <label className="drawer-checkbox-row">
            <input
              type="checkbox"
              value={promote}
              onChange={() => setPromote(!promote)}
              checked={promote} />
            
            <span>Enable recruiter as College Admin</span>
          </label>

          <label className="drawer-checkbox-row">
            <input
              type="checkbox"
              value={premium}
              onChange={() => setPremium(!premium)}
              checked={!!premium} />
            
            <span>Assign Premium Service</span>
          </label>

          {showPasswordError &&
          <p className="drawer-password-error">{showPasswordError}</p>}
          
        </div>

        <div className="drawer-footer">
          {modify &&
          <button
            type="button"
            className="drawer-btn-delete"
            onClick={() => setOpenDeleteModal(true)}>
            
              <FontAwesomeIcon icon={faTrash} />
              Delete
            </button>}
          
          {!modify ?
          <button
            type="button"
            onClick={saveButtonHandler}
            disabled={
            !(
            email &&
            firstName &&
            lastName &&
            password &&
            confirmPassword &&
            !showPasswordError)}


            className="drawer-btn-save">
            
              <FontAwesomeIcon icon={faSave} />
              Save
            </button> :

          <button
            type="button"
            onClick={saveButtonHandler}
            className="drawer-btn-save">
            
              <FontAwesomeIcon icon={faSave} />
              Save
            </button>}
          
        </div>
      </div>
      {openDeleteModal &&
      <MessageModal
        setIsOpen={setOpenDeleteModal}
        isOpen={openDeleteModal}
        data={{
          function1: deleteCounslor,
          message: "Are you sure you want to delete?"
        }} />}

      
    </Fragment>);

};
export default CreateRecruiter;